import { useMemo } from "react";

/**
 * A simple hook for client-side pagination
 * @param {Array} data - The full array of items to paginate
 * @param {number} page - Current page number
 * @param {number} limit - Items per page
 */
export const useClientPagination = (data = [], page = 1, limit = 10) => {
  const totalItems = data?.length || 0;
  const totalPages = Math.ceil(totalItems / limit);

  const paginatedData = useMemo(() => {
    const startIndex = (page - 1) * limit;
    return (data || []).slice(startIndex, startIndex + limit);
  }, [data, page, limit]);

  return {
    paginatedData,
    totalItems,
    totalPages,
    hasNextPage: page < totalPages,
    hasPrevPage: page > 1
  };
};
